/* eslint-disable jira/filename-case */
export default {
	get(): boolean {
		return true;
	},
};
